/**
 * In-memory mirror of GET /api/permissions/catalog (DB + Redis on server).
 * Populated once per session via usePermissionCatalog / ensurePermissionCatalogLoaded.
 */
import type { RbacCatalogSnapshot } from '@/services/api/shared/rbac-catalog.service'

let snapshot: RbacCatalogSnapshot | null = null
let keySet: Set<string> | null = null

export function setPermissionCatalogFromSnapshot(next: RbacCatalogSnapshot): void {
  snapshot = next
  keySet = new Set(next.keys.map((k) => k.trim()).filter(Boolean))
}

export function getPermissionCatalogSnapshot(): RbacCatalogSnapshot | null {
  return snapshot
}

export function getRbacPermissionCatalogSet(): Set<string> {
  return keySet ?? new Set()
}

export function isPermissionCatalogLoaded(): boolean {
  return keySet != null && keySet.size > 0
}

export function clearPermissionCatalogCache(): void {
  snapshot = null
  keySet = null
}

/** PCS-style key: scope.domain.action */
const PERMISSION_KEY_FORMAT =
  /^(platform|organization|branch)\.[a-z][a-z0-9_]*\.(view|create|edit|delete)$/i

export function isValidPermissionKeyFormat(key: string): boolean {
  return PERMISSION_KEY_FORMAT.test(key.trim())
}
